var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"items":_vm.itemsComputed,"rules":_vm.rules,"loading":_vm.loading || _vm.itemsLoading,"label":_vm.label,"placeholder":"Select existing or type new"},model:{value:(_vm.valueComputed),callback:function ($$v) {_vm.valueComputed=$$v},expression:"valueComputed"}})
}
var staticRenderFns = []

export { render, staticRenderFns }